export const iconFontAwesomeMarketingOtter = (
	<i className="fa-solid fa-otter"></i>
);
